import React from "react";
import { withRouter } from "react-router-dom";
import Logo from "./Logo";

import MenuMarkup from "./MenuMarkup/MenuMarkup";
import ResponsiveNav from "./ResponsiveNav/ResponsiveNav";

const Header = ({ location }) => {
  return (
    <div>
      <Logo />
      <ResponsiveNav
        activeLinkKey={location.pathname}
        menuMarkup={MenuMarkup}
        placement="bottomLeft"
      />
    </div>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/menu/Header.js